import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IDecodeVinPayload, IVinDecodeResponse } from "./vinDecoder.types";

export const DECODE_VIN_PROGRESS = "DECODE_VIN_PROGRESS";
export const DECODE_VIN_SUCCESS = "DECODE_VIN_SUCCESS";
export const DECODE_VIN_FAILED = "DECODE_VIN_FAILED";

export const decodeVinProgress = () => action(DECODE_VIN_PROGRESS);
export const decodeVinSuccess = (data: IVinDecodeResponse) =>
  action(DECODE_VIN_SUCCESS, { data });
export const decodeVinFailed = (errorMessage: string) =>
  action(DECODE_VIN_FAILED, { errorMessage });

export const decodeVinAsync =
  (
    vin: string,
    onComplete?: (isSuccess: boolean, data?: IVinDecodeResponse) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
      try {
        dispatch(decodeVinProgress());
        const payload: IDecodeVinPayload = {
          vin: vin.trim(),
          companyCode: "HM",
          language: "EN",
          status: "ACTIVE",
        };
        const res = await api.post("/ibc/decode-vin", payload);
        const data: IVinDecodeResponse = res.data.data.vinInfo;
        // const data = {
        //   "success": true,
        //   "message": "VIN decoded successfully",
        //   "data": {
        //     "sysErrors": [],
        //     "vinInfo": {
        //       "decodeErrors": [],
        //       "vin": "JN8BT3BB5SW142381",
        //       "yearCode": "S",
        //       "yearValue": "2025",
        //       "sequentialNumber": "142381",
        //       "vehicleType": "Private Passenger Vehicle",
        //       "marketingMakes": [
        //         {
        //           "description": "NISSAN",
        //           "models": [
        //             {
        //               "description": "ROGUE SV 4DR AWD",
        //               "code": "147802",
        //               "products": [
        //                 {
        //                   "description": "CODE DE VÉHICULE",
        //                   "code": "1478"
        //                 },
        //                 {
        //                   "description": "CODE DE VÉHICULE PROLONGÉ",
        //                   "code": "147802"
        //                 },
        //                 {
        //                   "description": "Body Style",
        //                   "code": "MP"
        //                 },
        //                 {
        //                   "description": "Drive Train",
        //                   "code": "2"
        //                 },
        //                 {
        //                   "description": "CSIO Body Type Indicator",
        //                   "code": "SU"
        //                 },
        //                 {
        //                   "description": "IBC Approved TDS",
        //                   "code": "Y"
        //                 }
        //               ]
        //             }
        //           ]
        //         }
        //       ]
        //     }
        //   }
        // }
        if (!onComplete) {
          dispatch(decodeVinSuccess(data));
        }
        else {
          onComplete(true, data);
        }

      } catch (err: any) {
        dispatch(decodeVinFailed(err.response.data.message));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          }),
        );
        onComplete?.(false);
      }
    };
